import React from 'react';
import classnames from 'classnames';
import { FacetData, FacetValueData } from '../../../../types';
import styles from './facet.module.pcss';

interface FacetProps {
  facet: FacetData;
  facetValueData: FacetValueData;
  facetSelectionHandler: (facetValue: FacetValueData, facetData: FacetData) => void;
}

function Facet({ facet, facetValueData: value, facetSelectionHandler }: FacetProps): React.ReactElement {
  return (
    <button
      role="checkbox"
      aria-checked={value.selected}
      type="button"
      disabled={value.disabled && !value.selected}
      className={classnames(styles.facet, 'rolex-text-button rolex-text-button--black-primary rolex-spacing-20')}
      onClick={(): void => facetSelectionHandler(value, facet)}
    >
      <span
        className={classnames(styles['facet__checkbox'], {
          [styles['facet__checkbox--checked']]: value.selected
        })}
      />
      <span className={styles['facet__name']}>{value.name}</span>
    </button>
  );
}

export default Facet;
